export var AppUiSharedComponentsSubjects;
(function (AppUiSharedComponentsSubjects) {
    AppUiSharedComponentsSubjects["FilterEditPopover"] = "filter-edit-popover";
    AppUiSharedComponentsSubjects["FilterEditFieldSelect"] = "filter-edit-field-select";
    AppUiSharedComponentsSubjects["FilterEditOperatorSelect"] = "filter-edit-operator-select";
    AppUiSharedComponentsSubjects["FilterEditValueSelect"] = "filter-edit-value-select";
    AppUiSharedComponentsSubjects["FilterEditApplyButton"] = "filter-edit-apply-button";
    AppUiSharedComponentsSubjects["FilterEditCancelButton"] = "filter-edit-cancel-button";
})(AppUiSharedComponentsSubjects || (AppUiSharedComponentsSubjects = {}));
//# sourceMappingURL=app-ui-shared-components.enum.js.map